up.link.config.followSelectors.push('a[href]')